"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gear = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const Gear = ({ size = 16, title = "Gear icon", ...rest }) => (react_1.default.createElement(Base_1.Base, { size: size, smooth: true, ...rest },
    react_1.default.createElement("title", null, title),
    react_1.default.createElement("path", { d: "M16 9.2V6.8l-2.2-.4-.5-1.3 1.2-1.9-1.7-1.7-1.9 1.2-1.3-.5L9.2 0H6.8l-.5 2.2-1.3.5-1.8-1.2-1.7 1.7 1.2 1.9-.5 1.3-2.2.4v2.4l2.2.5.5 1.3-1.2 1.8 1.7 1.7 1.9-1.2 1.3.5.4 2.2h2.4l.5-2.2 1.3-.5 1.9 1.2 1.6-1.6-1.2-2 .5-1.3zm-8 2.4C6 11.6 4.4 10 4.4 8S6 4.4 8 4.4 11.6 6 11.6 8 10 11.6 8 11.6z" })));
exports.Gear = Gear;
//# sourceMappingURL=Gear.js.map